import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import Hero from "./components/Hero";
import CategorySection from "./components/CategorySection";
import WhySection from "./components/WhySection";
import GuidesSection from "./components/GuidesSection";
import FaqSection from "./components/FaqSection";
import FinalCta from "./components/FinalCta";

export default function Home() {
  const { hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const id = hash.replace("#", "");
      const timer = setTimeout(() => {
        document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
      }, 100);
      return () => clearTimeout(timer);
    }
  }, [hash]);

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <Hero />
        <CategorySection />
        <WhySection />
        <GuidesSection />
        <FaqSection />
        <FinalCta />
      </main>
      <Footer />
    </div>
  );
}